<template>
  <div class="error">
    <div class="modal fade in" id="submodal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: block; padding-right: 17px;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button @click="handleCloseWin" type="button" class="close" data-dismiss="modal" aria-label="Close" autocomplete="off"><span aria-hidden="true" style="font-size: 20px;">×</span></button>
                    <h4 class="modal-title" id="myModalLabel">题型</h4>
                </div>
                <div class="modal-body">
                    <form action="index.php?exam-app-point-errors" method="post" class="form-horizontal" style="padding:20px;" id="reporterrorform">
                        <fieldset>
                            <div class="form-group">
                                <label class="control-label col-sm-3">错误类型：</label>
                                <div class="col-sm-9">
                                    <div style="clear: both">
                                        <label class="checkbox-inline">
                                            <input type="checkbox" name="error" value="答案错误" autocomplete="off" v-model="type"><span>答案错误</span>
                                        </label>
                                    </div>
                                    <div style="clear: both">
                                        <label class="checkbox-inline">
                                            <input type="checkbox" name="error" value="题干错误" autocomplete="off" v-model="type"><span>题干错误</span>
                                        </label>
                                    </div>
                                    <div style="clear: both">
                                        <label class="checkbox-inline">
                                            <input type="checkbox" name="error" value="解析错误" autocomplete="off" v-model="type"><span>解析错误</span>
                                        </label>
                                    </div>
                                    <div style="clear: both">
                                        <label class="checkbox-inline">
                                            <input type="checkbox" name="error" value="其他错误" autocomplete="off" v-model="type"><span>其他错误</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-3">详情描述：</label>
                                <div class="col-sm-9">
                                    <textarea class="form-control" name="errorcontent" style="height:80px;margin-top: 10px;" needle="needle" msg="请填写错误描述" autocomplete="off" v-model="content"></textarea>
                                </div>
                            </div>
                          <!--  <div class="form-group">
                                <label class="control-label col-sm-2"></label>
                                <div class="col-sm-10">
                                    <button class="btn btn-primary hide btn-block" type="submit" autocomplete="off">提交</button>
                                    <input type="hidden" name="questionid" value="205436" autocomplete="off">
                                    <input type="hidden" name="adderrors" value="1" autocomplete="off">
                                </div>
                            </div> -->
                        </fieldset>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal" @click="handleSubmit" autocomplete="off">提交</button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  let timer;
  export default {
    name: 'Footer',
    components:{

    },
    props:{
      questionId:{
          type:String,
          default:()=>''
      },
    },
    data () {
      return {
        content:'',
        type:[]
      }
    },
    methods:{
        handleCloseWin(){
          this.$emit('closewin')
        },
        handleSubmit(){
            if(this.type.length==0){
              alert('请选择错误类型');
              return
            }
            if(this.content==''){
              alert('请填写错误描述');
              return
            }
            let data=new FormData();
                data.append('questionId',this.questionId);
                data.append('content',this.content);
                data.append('type',this.type.join());
                
            this.$axios.post(this.$common.questionErrorCorrection_sub,data).then((res)=>{
                  if(res.data.code==1){
                      this.content=''
                      alert('谢谢您的反馈')
                      this.$emit('closewin')
            
            
                  }
                  else {
                    alert(res.data.msg)
                  }
            })
        }
    },
    created() {
      document.querySelector('body').className='overflowhidden'

    },
    beforeDestroy() {
      document.querySelector('body').className=''
    }
  }
</script>

<style scoped>
  .error {
    position: fixed;
        right: 0;
        top: 0;
        z-index: 1988;
        width: 100%;
        z-index: 1988;
        height: 100vh;
        overflow: hidden;
        background: rgba(0,0,0,.4);
  }
  .fade {
      opacity: 0;
      -webkit-transition: opacity .15s linear;
      -o-transition: opacity .15s linear;
      transition: opacity .15s linear;
  }
  .modal {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1050;
      display: none;
      overflow: hidden;
      -webkit-overflow-scrolling: touch;
      outline: 0;
  }
  .fade.in {
      opacity: 1;
  }
  .modal-open .modal {
      overflow-x: hidden;
      overflow-y: auto;
  }
  .modal-dialog {
      position: relative;
      width: auto;
      margin: 10px;
  }
  .modal-dialog {
      width: 600px;
      margin: 30px auto;
  }
  .modal.fade .modal-dialog {
      -webkit-transition: -webkit-transform .3s ease-out;
      -o-transition: -o-transform .3s ease-out;
      transition: transform .3s ease-out;
      -webkit-transform: translate(0, -25%);
      -ms-transform: translate(0, -25%);
      -o-transform: translate(0, -25%);
      transform: translate(0, -25%);
  }
  .modal.in .modal-dialog {
      -webkit-transform: translate(0, 0);
      -ms-transform: translate(0, 0);
      -o-transform: translate(0, 0);
      transform: translate(0, 0);
  }
  .modal-content {
      position: relative;
      background-color: #fff;
      -webkit-background-clip: padding-box;
      background-clip: padding-box;
      border: 1px solid #999;
      border: 1px solid rgba(0, 0, 0, .2);
      border-radius: 6px;
      outline: 0;
      -webkit-box-shadow: 0 3px 9px rgb(0 0 0 / 50%);
      box-shadow: 0 3px 9px rgb(0 0 0 / 50%);
  }
  .modal-content {
      -webkit-box-shadow: 0 5px 15px rgb(0 0 0 / 50%);
      box-shadow: 0 5px 15px rgb(0 0 0 / 50%);
  }
  .modal .modal-content {
      border-radius: 0px;
  }
  .modal-header {
      padding: 15px;
      border-bottom: 1px solid #e5e5e5;
  }
  .modal .modal-header {
      padding-top: 20px;
      padding-left: 20px;
  }
  .modal-body {
      position: relative;
      padding: 15px;
  }
  .modal .modal-body {
      font-size: 16px;
      line-height: 32px;
  }
  .modal-footer {
      padding: 15px;
      text-align: right;
      border-top: 1px solid #e5e5e5;
  }
  .close {
      float: right;
      font-size: 21px;
      font-weight: bold;
      line-height: 1;
      color: #000;
      text-shadow: 0 1px 0 #fff;
      filter: alpha(opacity=20);
      opacity: .2;
  }
  button.close {
      -webkit-appearance: none;
      padding: 0;
      cursor: pointer;
      background: transparent;
      border: 0;
  }
  .modal-header .close {
      margin-top: -2px;
  }
  .modal .modal-header button {
      font-size: 28px;
  }
  .modal-title {
      margin: 0;
      line-height: 1.42857143;
  }
  fieldset {
      min-width: 0;
      padding: 0;
      margin: 0;
      border: 0;
  }
  .form-group {
      margin-bottom: 15px;
  }
  .form-horizontal .form-group {
      margin-right: -15px;
      margin-left: -15px;
  }
  .col-sm-3 {
      width: 25%;
  }
  .form-horizontal .control-label {
      padding-top: 7px;
      margin-bottom: 0;
      text-align: right;
  }
  .modal .modal-body label {
      line-height: 36px;
  }
  .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {
      float: left;
  }
  .col-sm-9 {
      width: 75%;
  }
  label {
      display: inline-block;
      max-width: 100%;
      margin-bottom: 5px;
      font-weight: bold;
  }
  .radio-inline, .checkbox-inline {
      position: relative;
      display: inline-block;
      padding-left: 20px;
      margin-bottom: 0;
      font-weight: normal;
      vertical-align: middle;
      cursor: pointer;
  }
  .form-horizontal .radio, .form-horizontal .checkbox, .form-horizontal .radio-inline, .form-horizontal .checkbox-inline {
      padding-top: 7px;
      margin-top: 0;
      margin-bottom: 0;
  }
  .modal .modal-body label {
      line-height: 36px;
  }
  input, button, select, textarea {
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
  }
  input[type="checkbox"], input[type="radio"] {
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 0;
  }
  input[type="radio"], input[type="checkbox"] {
      margin: 4px 0 0;
      margin-top: 1px \9;
      line-height: normal;
      margin-right: 10px;
  }
  .modal .btn.btn-default {
      color: #02756E;
      border-color: #02756E;
      outline: none;
      border: 1px solid #02756E;
      cursor: pointer;
  }
  .modal .btn {
      padding: 10px 25px;
      border-radius: 0px;
      margin-left: 14px!important;
  }
  textarea {
    width: 80%;
    outline: none;
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/error.vue